import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props, StatusPillVariant } from './types';

import styles from './styles.module.scss';

const variantClassMap: Record<StatusPillVariant, string> = {
    error: styles.error,
    ok: styles.ok,
    warn: styles.warn
};

const StatusPill: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text,
    variant
}) => {
    const variantClass = variantClassMap[variant];

    return (
        <Wrapper className={`${styles.statusPill} ${variantClass} ${className}`} testId={testId}>
            {text}
        </Wrapper>
    );
};

export default StatusPill;
